// Energy Machines constants

const ENERGY_MACHINES_ORGANIZATION_ID_PROD = "org_9EDq0dDHwJtrbhGs"; // These are Auth0 organization id's.
const ENERGY_MACHINES_ORGANIZATION_ID_DEV = "org_U6yhWOdOmxkmSTwb"; // These are Auth0 organization id's.

export const ENERGY_MACHINES_ORGANIZATION_ID = import.meta.env.DEV
  ? ENERGY_MACHINES_ORGANIZATION_ID_DEV
  : ENERGY_MACHINES_ORGANIZATION_ID_PROD;

export const ENERGY_MACHINES_CUSTOM_URL_HOST =
  "system-designer.energymachines.com";

// End of Energy Machines constants

// Energy Machines SIMULATE constants
export const SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST =
  "simulate.energymachines.com";

// For the simulate.energymachines.com domain we use the same Auth0 organizations - this custom url is only used as an alias
export const SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID = import.meta.env.DEV
  ? ENERGY_MACHINES_ORGANIZATION_ID_DEV
  : ENERGY_MACHINES_ORGANIZATION_ID_PROD;

// End of Energy Machines SIMULATE constants

// Clean Heat Partners constants

const CLEAN_HEAT_PARTNERS_ORGANIZATION_ID_PROD = "org_I75CUe3r2Y6KXzwi"; // These are Auth0 organization id's.
const CLEAN_HEAT_PARTNERS_ORGANIZATION_ID_DEV = "org_9ehCMPdfPs8DHhCq"; // These are Auth0 organization id's.

export const CLEAN_HEAT_PARTNERS_ORGANIZATION_ID = import.meta.env.DEV
  ? CLEAN_HEAT_PARTNERS_ORGANIZATION_ID_DEV
  : CLEAN_HEAT_PARTNERS_ORGANIZATION_ID_PROD;

export const CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST =
  "platform.cleanheatpartners.com";

// End of Clean Heat Partners constants

// WeDoSCM constants

export const WEDOSCM_CUSTOM_URL_HOST =
  "platform.wedoscm.com";

// End of WeDoSCM constants
